import { SxPropsTypes } from '../../theme/MuiThemeProvider/types';

export const styles: SxPropsTypes = {
  button: {
    width: '32px',
    height: '32px',
    padding: '4px',
  },
};
